import WORK1 from "../../assets/works/work1.png"
import WORK2 from "../../assets/works/work2.png"
import WORK3 from "../../assets/works/work3.png"
import WORK4 from "../../assets/works/work4.png"
import WORK5 from "../../assets/works/work5.png"
import WORK6 from "../../assets/works/work6.png"
import WORK7 from "../../assets/works/work7.png"
import WORK8 from "../../assets/works/work8.png"
import WORK9 from "../../assets/works/work9.png"
import WORK10 from "../../assets/works/work10.png"
import WORK11 from "../../assets/works/work11.png"
import WORK12 from "../../assets/works/work12.png"
import WORK13 from "../../assets/works/work13.png"
import WORK14 from "../../assets/works/work14.png"
import WORK15 from "../../assets/works/work15.png"
import WORK16 from "../../assets/works/work16.png"

export const projectsData = [
    {
      id: 1,
      image: WORK1,
      title: "Moverse App",
      category: "React js",
      glink: "https://github.com/shubham369963/Moverse",
      link: "https://moverse-app.onrender.com/"
    },
    {
      id: 2,
       image: WORK2,
      title: "Codify App",
      category: "React js",
      glink: "https://github.com/shubham369963/Codify",
      link: "https://codify-app.onrender.com/"
    },
    {
      id: 3,
       image: WORK3,
      title: "Bloome App",
      category: "React js",
      glink: "https://github.com/shubham369963/bloome",
      link: "https://bloome-app.onrender.com/"
    },
    {
      id: 4,
       image: WORK4,
      title: "Upcode App",
      category: "Node js",
      glink: "https://github.com/shubham369963/Nodejs-upcode",
      link: "https://upcode-app.onrender.com/"
    },
    {
      id: 5,
       image: WORK5,
      title: "Inshorts Clone App",
      category: "React js",
      glink: "https://github.com/shubham369963/Inshorts_App",
      link: "https://inshort-app.onrender.com"
    },
    {
      id: 6,
       image: WORK6,
      title: "Mosaic App",
      category: "Node js",
      glink: "https://github.com/shubham369963/Mosaic",
      link: "https://mosaic-app.onrender.com/"
    },
    {
      id: 7,
       image: WORK7,
      title: "Romify App",
      category: "Node js",
      glink: "https://github.com/shubham369963/Romify",
      link: "https://romify-app.onrender.com/"
    },
    {
      id: 8,
       image: WORK8,
      title: "Yoga Registartion Form",
      category: "React js",
      glink: "https://github.com/shubham369963/yogaRegistration",
      link: "https://shubham369963.github.io/yogaRegistration/"
    },
    {
      id: 9,
       image: WORK9,
      title: "Weather App",
      category: "js",
      glink: "https://github.com/shubham369963/weatherFinder",
      link: "https://shubham369963.github.io/weatherFinder/"
    },
    {
      id: 10,
       image: WORK10,
      title: "frontend Editor",
      category: "js",
      glink: "https://github.com/shubham369963/frontendEditor",
      link: "https://shubham369963.github.io/frontendEditor/"
    },
    {
      id: 11,
       image: WORK11,
      title: "Magic Notes",
      category: "js",
      glink: "https://github.com/shubham369963/Notes_Maker_App",
      link: "https://shubham369963.github.io/Notes_Maker_App/"
    },
    {
      id: 12,
       image: WORK12,
      title: "Currency Converter",
      category: "js",
      glink: "https://github.com/shubham369963/currencyConverter",
      link: "https://shubham369963.github.io/currencyConverter/"
    },
    {
      id: 13,
       image: WORK13,
      title: "Translator",
      category: "js",
      glink: "https://github.com/shubham369963/Translator",
      link: "https://shubham369963.github.io/Translator/"
    },
    {
      id: 14,
       image: WORK14,
      title: "Quotes Finder",
      category: "js",
      glink: "https://github.com/shubham369963/motivationalQuotesFinder",
      link: "https://shubham369963.github.io/motivationalQuotesFinder/"
    },
    {
      id: 15,
       image: WORK15,
      title: "Calculator",
      category: "Simple",
      glink: "https://github.com/shubham369963/Calculator",
      link: "https://shubham369963.github.io/Calculator/"
    },
    {
      id: 16,
       image: WORK16,
      title: "Login Form",
      category: "Simple",
      glink: "https://github.com/shubham369963/LoginForm",
      link: "https://shubham369963.github.io/LoginForm/"
    },
  ];

  export const projectNav = [
    {
        name: "all",
    },
    {
        name: "Node js",
    },
    {
        name: "React js",
    },
    {
      name: "js",
    },
    {
        name: "Simple",
    },
  ]